export default {
  dashboardNotificationTemplates: '/dashboard/notificationTemplates',
};
